import Vue from 'vue';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
const options ={
    position:"bottom-right"
}
Vue.use(Toast,options);
export default Toast
